<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <b-navbar
    type="light"
    variant="default"
  >
    <b-navbar-brand
      href="#/"
    >
      {{ $app.spec.brand }}
<ItpBadge v-if=displayTestBadge variant="danger" class="mx-2">Test</ItpBadge>
<ItpBadge v-if=displayDevBadge variant="warning" class="mx-2">Dev</ItpBadge>

    </b-navbar-brand>
    <b-collapse
      is-nav
    >
      <b-navbar-nav>
        <b-nav-item-dropdown>
          <template
            slot="button-content"
          >
            {{ 'Finance'|pgettext('MainMenu') }}
          </template>
          <ItpDropdownText>
            {{ 'Register'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/registers"
            :icon="$config.register.icon"
            :text="'Registers'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpDropdownText>
            {{ 'Customer invoices'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/invoices-out"
            :icon="$config.invoice.customerInvoiceIcon"
            :text="'Customer invoices'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Customer Invoice...'|pgettext('MainMenu')"
            :icon="$config.invoice.customerInvoiceIcon"
            dropdown-item
            @click.prevent="evh_4446976243747050_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/billing-list"
            :icon="$config.billingList.icon"
            :text="'Billing List'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/invoice-generation"
            :icon="$config.invoiceGeneration.icon"
            :text="'Invoice Generation'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpDropdownText>
            {{ 'Incoming invoices'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/invoices-in"
            :icon="$config.invoice.vendorInvoiceIcon"
            :text="'Incoming invoices'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Incoming Invoice...'|pgettext('MainMenu')"
            :icon="$config.invoice.icon"
            dropdown-item
            @click.prevent="evh_5794187517758435_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpDropdownText>
            {{ 'Payments'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/payments"
            :icon="$config.payment.paymentsList.icon"
            :text="'Payments'|pgettext('PaymentsView')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/accounts-daily-flow"
            :icon="$config.accountsDailyFlow.icon"
            :text="'Accounts Daily Flow'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Cash In...'|pgettext('Create Payment')"
            :icon="$config.payment.cash.icon"
            dropdown-item
            @click.prevent="evh_8440793417118356_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Cash Out...'|pgettext('Create Payment')"
            :icon="$config.payment.cash.icon"
            dropdown-item
            @click.prevent="evh_6201675214105229_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Banking...'|pgettext('Create Payment')"
            :icon="$config.payment.banking.icon"
            dropdown-item
            @click.prevent="evh_6373990564425123_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Account statement report...'|pgettext('MeinMenu')"
            :icon="$config.accountStatementReport.icon"
            dropdown-item
            @click.prevent="evh_8819772728062230_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpDropdownText>
            {{ 'Claims management'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/claims"
            :icon="$config.claim.icon"
            :text="'Claims'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/dunning-letters"
            :icon="$config.dunningLetter.icon"
            :text="'Dunning letters'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown>
          <template
            slot="button-content"
          >
            {{ 'Assets'|pgettext('MainMenu') }}
          </template>
          <ItpNavItem
            to="/fixed-assets"
            :icon="$config.fixedAsset.icon"
            :text="'Fixed Assets'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Create Asset...'|pgettext('MainMenu')"
            :icon="$config.fixedAsset.icon"
            dropdown-item
            @click.prevent="evh_1886107574314164_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/waste-bins"
            :icon="$config.wasteBin.icon"
            :text="'Waste Bins'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/waste-bin-readings"
            :icon="$config.wasteBin.icon"
            :text="'Waste Bin Readings'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Create Waste Bin...'|pgettext('MainMenu')"
            :icon="$config.wasteBin.createWasteBinIcon"
            dropdown-item
            @click.prevent="evh_7260361660686930_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpDropdownText>
            {{ 'Meters'|pgettext('MainMenu') }}
          </ItpDropdownText>
          <ItpNavItem
            to="/meters"
            :icon="$config.meter.icon"
            :text="'Meters'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add Meter...'|pgettext('MainMenu')"
            :icon="$config.meter.addMeterIcon"
            dropdown-item
            @click.prevent="evh_5449511595610967_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            href="#"
            :icon="$config.meterReplacement.icon"
            :text="'Replace meter...'|pgettext('MainMenu')"
            dropdown-item
            @click.prevent="evh_5934241105726385_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/auto-readings"
            :icon="$config.meterAutoReading.icon"
            :text="'Auto Readings'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            href="#"
            icon="fa-upload"
            :text="'Meter Data Exchange...'|pgettext('MainMenu')"
            dropdown-item
            @click.prevent="evh_7807097906137782_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/meter-consumptions"
            :icon="$config.meterConsumption.icon"
            :text="'Meter consumptions'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown>
          <template
            slot="button-content"
          >
            {{ 'Contracts'|pgettext('MainMenu') }}
          </template>
          <ItpNavItem
            to="/contracts"
            :icon="$config.contract.icon"
            :text="'Contracts'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Create Contract...'|pgettext('MainMenu')"
            :icon="$config.contract.icon"
            dropdown-item
            @click.prevent="evh_2338624680052783_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/contract-services"
            :icon="$config.contract.icon"
            :text="'Contract services'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/contract-service-fees"
            :icon="$config.contract.icon"
            :text="'Contract service fees'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/contract-attachments"
            :icon="$config.attachmentIcon"
            :text="'Contract attachments'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            to="/contract-events"
            :icon="$config.contract.views.contractEvents.icon"
            :text="'Contract events'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/overlapping-revisions"
            :icon="$config.contract.views.overlappingRevisions.icon"
            :text="'Overlapping Revisions'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            href="#"
            icon="gravity-ui:curly-brackets-function"
            :text="'Billing rules'|pgettext('MainMenu')"
            dropdown-item
            @click.prevent="evh_8542963707987136_clickPrevent($event, {})"
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown>
          <template
            slot="button-content"
          >
            {{ 'Worksheets'|pgettext('MainMenu') }}
          </template>
          <ItpNavItem
            to="/worksheets"
            :icon="$config.worksheet.icon"
            :text="'Worksheets'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New Worksheet...'|pgettext('MainMenu')"
            :icon="$config.worksheet.createWorksheetIcon"
            dropdown-item
            @click.prevent="evh_2596033535867385_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/worksheets-work-summary"
            :icon="$config.worksheet.icon"
            :text="'Work summary'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown>
          <template
            slot="button-content"
          >
            {{ 'Master data'|pgettext('MainMenu') }}
          </template>
          <ItpNavItem
            to="/products"
            :icon="$config.product.icon"
            :text="'Products'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'New product/service...'|pgettext('MainMenu')"
            :icon="$config.product.addProductIcon"
            dropdown-item
            @click.prevent="evh_2660996057968802_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Tariffs...'|pgettext('MainMenu')"
            :icon="$config.tariff.icon"
            dropdown-item
            @click.prevent="evh_2344870777941005_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/rentals"
            :icon="$config.rental.icon"
            :text="'Rentals'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add Rental...'|pgettext('MainMenu')"
            :icon="$config.rental.addRentalIcon"
            dropdown-item
            @click.prevent="evh_2858245741222179_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpNavItem
            to="/rental-services"
            :icon="$config.rental.icon"
            :text="'Rental services'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/projects"
            :icon="$config.project.icon"
            :text="'Projects'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add project...'|pgettext('MainMenu')"
            :icon="$config.project.addProjectIcon"
            dropdown-item
            @click.prevent="evh_5458292690736167_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/properties"
            :icon="$config.property.icon"
            :text="'Locations'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add property...'|pgettext('MainMenu')"
            :icon="$config.property.addPropertyIcon"
            dropdown-item
            @click.prevent="evh_5517551119992435_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/partners"
            :icon="$config.company.icons.partner"
            :text="'Partners'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add partner...'|pgettext('MainMenu')"
            :icon="$config.company.icons.partner"
            dropdown-item
            @click.prevent="evh_2718428830017525_clickPrevent($event, {})"
          >
          </ItpNavItem>
          <ItpDropdownDivider>
          </ItpDropdownDivider>
          <ItpNavItem
            to="/own-companies"
            :icon="$config.company.icons.own"
            :text="'Own companies'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            :text="'Add company...'|pgettext('MainMenu')"
            :icon="$config.company.icons.own"
            dropdown-item
            @click.prevent="evh_4595210157189327_clickPrevent($event, {})"
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <Charts>
        </Charts>
      </b-navbar-nav>
      <b-navbar-nav
        class="ml-auto"
      >
        <b-nav-item-dropdown
          right
          class="mx-3"
        >
          <template
            slot="button-content"
          >
            <ItpIcon
              name="fa-user-circle"
              class="mr-1"
            >
            </ItpIcon>
            <span>
              {{ $app.auth.user.fullName || $app.auth.user.userName }}
            </span>
          </template>
          <ItpNavItem
            :href="$app.auth.accountUrl"
            target="_blank"
            icon="fa-user-circle"
            :text="'Profile'|pgettext('MainMenu')"
            dropdown-item
          >
          </ItpNavItem>
          <ItpNavItem
            icon="fa-globe"
          >
            <ItpLocaleSelector
              class="nav-item-content"
            >
            </ItpLocaleSelector>
          </ItpNavItem>
          <b-dropdown-divider>
          </b-dropdown-divider>
          <ItpNavItem
            icon="line-md:confirm-circle"
          >
            <BFormCheckbox
              v-model="$app.confirmPageClose"
              switch
              class="nav-item-content"
              @change="evh_298118714321807_change($event, {})"
            >
              <ItpText
                :text="'Confirm tab close'|pgettext('MainMenu')"
                class="user-select-none"
              >
              </ItpText>
            </BFormCheckbox>
          </ItpNavItem>
          <ItpNavItem
            href="#"
            icon="fa-sign-out-alt"
            :text="'Sign out'|pgettext('MainMenu')"
            dropdown-item
            @click.prevent="evh_7106235911078350_clickPrevent($event, {})"
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          right
        >
          <ItpIcon
            name="fa-bars"
            slot="button-content"
          >
          </ItpIcon>
          <ItpNavItem
            dropdown-item
            to="/jobs-v2"
            icon="fa-cogs"
            :text="'Jobs'|pgettext('MainMenu')"
          >
          </ItpNavItem>
          <ItpNavItem
            dropdown-item
            to="/attachments"
            :icon="$config.attachment.icon"
            :text="'Attachments'|pgettext('MainMenu')"
          >
          </ItpNavItem>
          <ItpNavItem
            dropdown-item
            to="/templates"
            icon="fa-file-invoice"
            :text="'Templates'|pgettext('MainMenu')"
          >
          </ItpNavItem>
          <b-dropdown-divider>
          </b-dropdown-divider>
          <ItpNavItem
            dropdown-item
            to="/settings"
            icon="fa-cog"
            :text="'Settings'|pgettext('MainMenu')"
          >
          </ItpNavItem>
          <ItpNavItem
            href="#"
            icon="fa-question-circle"
            :text="'About Integro'|pgettext('MainMenu')"
            dropdown-item
            @click.prevent="evh_5361165673534032_clickPrevent($event, {})"
          >
          </ItpNavItem>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MainMenu extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get displayTestBadge() {
    if (this.loaded) {

      return _.includes(this.$app.document.location.hostname, 'test')
    }
    return null;
  }

  get displayDevBadge() {
    if (this.loaded) {

      return _.includes(this.$app.document.location.hostname, 'local')
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_4446976243747050_showModal_1720_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4446976243747050_showModal_1720, alias=undefined
    return {
      name: "CreateInvoice",
      props: {
        invoiceKind: "outgoing",
      }
      ,
    }
  }

  async evh_4446976243747050_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4446976243747050_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5794187517758435_showModal_1722_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5794187517758435_showModal_1722, alias=undefined
    return {
      name: "CreateInvoice",
      props: {
        invoiceKind: "incoming",
      }
      ,
    }
  }

  async evh_5794187517758435_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5794187517758435_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_8440793417118356_showModal_1724_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8440793417118356_showModal_1724, alias=undefined
    return {
      name: "Payment",
      props: {
        transactionKind: "cash_book",
        transactionType: "deposit",
      }
      ,
    }
  }

  async evh_8440793417118356_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8440793417118356_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_6201675214105229_showModal_1726_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6201675214105229_showModal_1726, alias=undefined
    return {
      name: "Payment",
      props: {
        transactionKind: "cash_book",
        transactionType: "payment",
      }
      ,
    }
  }

  async evh_6201675214105229_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6201675214105229_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_6373990564425123_showModal_1728_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6373990564425123_showModal_1728, alias=undefined
    return {
      name: "Payment",
      props: {
        transactionKind: "bank",
      }
      ,
    }
  }

  async evh_6373990564425123_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6373990564425123_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_8819772728062230_showModal_1730_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8819772728062230_showModal_1730, alias=undefined
    return {
      name: "AccountStatementReport",
    }
  }

  async evh_8819772728062230_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8819772728062230_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_1886107574314164_showModal_1732_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1886107574314164_showModal_1732, alias=undefined
    return {
      name: "MCreateFixedAsset",
      props: {
        assetType: "general",
      }
      ,
    }
  }

  async evh_1886107574314164_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1886107574314164_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_7260361660686930_showModal_1734_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7260361660686930_showModal_1734, alias=undefined
    return {
      name: "MCreateFixedAsset",
      props: {
        assetType: "waste_bin",
      }
      ,
    }
  }

  async evh_7260361660686930_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7260361660686930_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5449511595610967_showModal_1736_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5449511595610967_showModal_1736, alias=undefined
    return {
      name: "CreateMeter",
    }
  }

  async evh_5449511595610967_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5449511595610967_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5934241105726385_showModal_1738_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5934241105726385_showModal_1738, alias=undefined
    return {
      name: "ReplaceMeter",
    }
  }

  async evh_5934241105726385_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5934241105726385_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_7807097906137782_showModal_1740_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7807097906137782_showModal_1740, alias=undefined
    return {
      name: "MeterDataExchange",
    }
  }

  async evh_7807097906137782_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7807097906137782_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2338624680052783_showModal_1742_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2338624680052783_showModal_1742, alias=undefined
    return {
      name: "CreateContract",
    }
  }

  async evh_2338624680052783_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2338624680052783_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_8542963707987136_showModal_1744_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8542963707987136_showModal_1744, alias=undefined
    return {
      name: "BillingRules",
    }
  }

  async evh_8542963707987136_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8542963707987136_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2596033535867385_showModal_1746_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2596033535867385_showModal_1746, alias=undefined
    return {
      name: "Worksheet",
      props: {
        size: "lg",
      }
      ,
    }
  }

  async evh_2596033535867385_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2596033535867385_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2660996057968802_showModal_1748_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2660996057968802_showModal_1748, alias=undefined
    return {
      name: "CreateProduct",
    }
  }

  async evh_2660996057968802_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2660996057968802_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2344870777941005_showModal_1750_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2344870777941005_showModal_1750, alias=undefined
    return {
      name: "Tariffs",
    }
  }

  async evh_2344870777941005_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2344870777941005_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2858245741222179_showModal_1752_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2858245741222179_showModal_1752, alias=undefined
    return {
      name: "CreateRental",
    }
  }

  async evh_2858245741222179_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2858245741222179_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5458292690736167_showModal_1754_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5458292690736167_showModal_1754, alias=undefined
    return {
      name: "CreateProject",
    }
  }

  async evh_5458292690736167_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5458292690736167_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5517551119992435_showModal_1756_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5517551119992435_showModal_1756, alias=undefined
    return {
      name: "CreateProperty",
    }
  }

  async evh_5517551119992435_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5517551119992435_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_2718428830017525_showModal_1758_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2718428830017525_showModal_1758, alias=undefined
    return {
      name: "CreateCompany",
      props: {
        role: "partner",
      }
      ,
    }
  }

  async evh_2718428830017525_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2718428830017525_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_4595210157189327_showModal_1760_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4595210157189327_showModal_1760, alias=undefined
    return {
      name: "CreateCompany",
      props: {
        role: "own",
      }
      ,
    }
  }

  async evh_4595210157189327_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4595210157189327_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_298118714321807_script_1762_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_298118714321807_script_1762, alias=undefined
    this.$app.toggleConfirmPageClose($event)
  }

  async act_298118714321807_script_1762_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_298118714321807_script_1762, alias=undefined
    return {
      value: () => this.act_298118714321807_script_1762_getActionArgs_value($event),
    }
  }

  async evh_298118714321807_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_298118714321807_change.executeFromDOM(this, event, scope);
  }

  async act_7106235911078350_logout_1764_getActionArgs($event: actions.ActionEvent): Promise<actions.LogoutActionArgs> {
    // parameterResolver name=act_7106235911078350_logout_1764, alias=undefined
    return {
    }
  }

  async evh_7106235911078350_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7106235911078350_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5361165673534032_showModal_1766_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5361165673534032_showModal_1766, alias=undefined
    return {
      name: "AboutModal",
    }
  }

  async evh_5361165673534032_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5361165673534032_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_1718: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_1717: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_4446976243747050_showModal_1720: actions.ShowModalAction;
    evh_4446976243747050_clickPrevent_1719: actions.EventHandlerImpl;
    evh_4446976243747050_clickPrevent: actions.EventHandlerGroup;
    act_5794187517758435_showModal_1722: actions.ShowModalAction;
    evh_5794187517758435_clickPrevent_1721: actions.EventHandlerImpl;
    evh_5794187517758435_clickPrevent: actions.EventHandlerGroup;
    act_8440793417118356_showModal_1724: actions.ShowModalAction;
    evh_8440793417118356_clickPrevent_1723: actions.EventHandlerImpl;
    evh_8440793417118356_clickPrevent: actions.EventHandlerGroup;
    act_6201675214105229_showModal_1726: actions.ShowModalAction;
    evh_6201675214105229_clickPrevent_1725: actions.EventHandlerImpl;
    evh_6201675214105229_clickPrevent: actions.EventHandlerGroup;
    act_6373990564425123_showModal_1728: actions.ShowModalAction;
    evh_6373990564425123_clickPrevent_1727: actions.EventHandlerImpl;
    evh_6373990564425123_clickPrevent: actions.EventHandlerGroup;
    act_8819772728062230_showModal_1730: actions.ShowModalAction;
    evh_8819772728062230_clickPrevent_1729: actions.EventHandlerImpl;
    evh_8819772728062230_clickPrevent: actions.EventHandlerGroup;
    act_1886107574314164_showModal_1732: actions.ShowModalAction;
    evh_1886107574314164_clickPrevent_1731: actions.EventHandlerImpl;
    evh_1886107574314164_clickPrevent: actions.EventHandlerGroup;
    act_7260361660686930_showModal_1734: actions.ShowModalAction;
    evh_7260361660686930_clickPrevent_1733: actions.EventHandlerImpl;
    evh_7260361660686930_clickPrevent: actions.EventHandlerGroup;
    act_5449511595610967_showModal_1736: actions.ShowModalAction;
    evh_5449511595610967_clickPrevent_1735: actions.EventHandlerImpl;
    evh_5449511595610967_clickPrevent: actions.EventHandlerGroup;
    act_5934241105726385_showModal_1738: actions.ShowModalAction;
    evh_5934241105726385_clickPrevent_1737: actions.EventHandlerImpl;
    evh_5934241105726385_clickPrevent: actions.EventHandlerGroup;
    act_7807097906137782_showModal_1740: actions.ShowModalAction;
    evh_7807097906137782_clickPrevent_1739: actions.EventHandlerImpl;
    evh_7807097906137782_clickPrevent: actions.EventHandlerGroup;
    act_2338624680052783_showModal_1742: actions.ShowModalAction;
    evh_2338624680052783_clickPrevent_1741: actions.EventHandlerImpl;
    evh_2338624680052783_clickPrevent: actions.EventHandlerGroup;
    act_8542963707987136_showModal_1744: actions.ShowModalAction;
    evh_8542963707987136_clickPrevent_1743: actions.EventHandlerImpl;
    evh_8542963707987136_clickPrevent: actions.EventHandlerGroup;
    act_2596033535867385_showModal_1746: actions.ShowModalAction;
    evh_2596033535867385_clickPrevent_1745: actions.EventHandlerImpl;
    evh_2596033535867385_clickPrevent: actions.EventHandlerGroup;
    act_2660996057968802_showModal_1748: actions.ShowModalAction;
    evh_2660996057968802_clickPrevent_1747: actions.EventHandlerImpl;
    evh_2660996057968802_clickPrevent: actions.EventHandlerGroup;
    act_2344870777941005_showModal_1750: actions.ShowModalAction;
    evh_2344870777941005_clickPrevent_1749: actions.EventHandlerImpl;
    evh_2344870777941005_clickPrevent: actions.EventHandlerGroup;
    act_2858245741222179_showModal_1752: actions.ShowModalAction;
    evh_2858245741222179_clickPrevent_1751: actions.EventHandlerImpl;
    evh_2858245741222179_clickPrevent: actions.EventHandlerGroup;
    act_5458292690736167_showModal_1754: actions.ShowModalAction;
    evh_5458292690736167_clickPrevent_1753: actions.EventHandlerImpl;
    evh_5458292690736167_clickPrevent: actions.EventHandlerGroup;
    act_5517551119992435_showModal_1756: actions.ShowModalAction;
    evh_5517551119992435_clickPrevent_1755: actions.EventHandlerImpl;
    evh_5517551119992435_clickPrevent: actions.EventHandlerGroup;
    act_2718428830017525_showModal_1758: actions.ShowModalAction;
    evh_2718428830017525_clickPrevent_1757: actions.EventHandlerImpl;
    evh_2718428830017525_clickPrevent: actions.EventHandlerGroup;
    act_4595210157189327_showModal_1760: actions.ShowModalAction;
    evh_4595210157189327_clickPrevent_1759: actions.EventHandlerImpl;
    evh_4595210157189327_clickPrevent: actions.EventHandlerGroup;
    act_298118714321807_script_1762: actions.ScriptAction;
    evh_298118714321807_change_1761: actions.EventHandlerImpl;
    evh_298118714321807_change: actions.EventHandlerGroup;
    act_7106235911078350_logout_1764: actions.LogoutAction;
    evh_7106235911078350_clickPrevent_1763: actions.EventHandlerImpl;
    evh_7106235911078350_clickPrevent: actions.EventHandlerGroup;
    act_5361165673534032_showModal_1766: actions.ShowModalAction;
    evh_5361165673534032_clickPrevent_1765: actions.EventHandlerImpl;
    evh_5361165673534032_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_1718 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_1717 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_1718,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_1717],
      }
    );
    const act_4446976243747050_showModal_1720 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4446976243747050_showModal_1720_getActionArgs,
        events: [],
      }
    );
    const evh_4446976243747050_clickPrevent_1719 = new actions.EventHandlerImpl(
      {
        action: act_4446976243747050_showModal_1720,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_4446976243747050_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_4446976243747050_clickPrevent_1719],
      }
    );
    const act_5794187517758435_showModal_1722 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5794187517758435_showModal_1722_getActionArgs,
        events: [],
      }
    );
    const evh_5794187517758435_clickPrevent_1721 = new actions.EventHandlerImpl(
      {
        action: act_5794187517758435_showModal_1722,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5794187517758435_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5794187517758435_clickPrevent_1721],
      }
    );
    const act_8440793417118356_showModal_1724 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8440793417118356_showModal_1724_getActionArgs,
        events: [],
      }
    );
    const evh_8440793417118356_clickPrevent_1723 = new actions.EventHandlerImpl(
      {
        action: act_8440793417118356_showModal_1724,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_8440793417118356_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_8440793417118356_clickPrevent_1723],
      }
    );
    const act_6201675214105229_showModal_1726 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6201675214105229_showModal_1726_getActionArgs,
        events: [],
      }
    );
    const evh_6201675214105229_clickPrevent_1725 = new actions.EventHandlerImpl(
      {
        action: act_6201675214105229_showModal_1726,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_6201675214105229_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_6201675214105229_clickPrevent_1725],
      }
    );
    const act_6373990564425123_showModal_1728 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6373990564425123_showModal_1728_getActionArgs,
        events: [],
      }
    );
    const evh_6373990564425123_clickPrevent_1727 = new actions.EventHandlerImpl(
      {
        action: act_6373990564425123_showModal_1728,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_6373990564425123_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_6373990564425123_clickPrevent_1727],
      }
    );
    const act_8819772728062230_showModal_1730 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8819772728062230_showModal_1730_getActionArgs,
        events: [],
      }
    );
    const evh_8819772728062230_clickPrevent_1729 = new actions.EventHandlerImpl(
      {
        action: act_8819772728062230_showModal_1730,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_8819772728062230_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_8819772728062230_clickPrevent_1729],
      }
    );
    const act_1886107574314164_showModal_1732 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1886107574314164_showModal_1732_getActionArgs,
        events: [],
      }
    );
    const evh_1886107574314164_clickPrevent_1731 = new actions.EventHandlerImpl(
      {
        action: act_1886107574314164_showModal_1732,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_1886107574314164_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1886107574314164_clickPrevent_1731],
      }
    );
    const act_7260361660686930_showModal_1734 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7260361660686930_showModal_1734_getActionArgs,
        events: [],
      }
    );
    const evh_7260361660686930_clickPrevent_1733 = new actions.EventHandlerImpl(
      {
        action: act_7260361660686930_showModal_1734,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_7260361660686930_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_7260361660686930_clickPrevent_1733],
      }
    );
    const act_5449511595610967_showModal_1736 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5449511595610967_showModal_1736_getActionArgs,
        events: [],
      }
    );
    const evh_5449511595610967_clickPrevent_1735 = new actions.EventHandlerImpl(
      {
        action: act_5449511595610967_showModal_1736,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5449511595610967_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5449511595610967_clickPrevent_1735],
      }
    );
    const act_5934241105726385_showModal_1738 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5934241105726385_showModal_1738_getActionArgs,
        events: [],
      }
    );
    const evh_5934241105726385_clickPrevent_1737 = new actions.EventHandlerImpl(
      {
        action: act_5934241105726385_showModal_1738,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5934241105726385_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5934241105726385_clickPrevent_1737],
      }
    );
    const act_7807097906137782_showModal_1740 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7807097906137782_showModal_1740_getActionArgs,
        events: [],
      }
    );
    const evh_7807097906137782_clickPrevent_1739 = new actions.EventHandlerImpl(
      {
        action: act_7807097906137782_showModal_1740,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_7807097906137782_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_7807097906137782_clickPrevent_1739],
      }
    );
    const act_2338624680052783_showModal_1742 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2338624680052783_showModal_1742_getActionArgs,
        events: [],
      }
    );
    const evh_2338624680052783_clickPrevent_1741 = new actions.EventHandlerImpl(
      {
        action: act_2338624680052783_showModal_1742,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2338624680052783_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2338624680052783_clickPrevent_1741],
      }
    );
    const act_8542963707987136_showModal_1744 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8542963707987136_showModal_1744_getActionArgs,
        events: [],
      }
    );
    const evh_8542963707987136_clickPrevent_1743 = new actions.EventHandlerImpl(
      {
        action: act_8542963707987136_showModal_1744,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_8542963707987136_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_8542963707987136_clickPrevent_1743],
      }
    );
    const act_2596033535867385_showModal_1746 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2596033535867385_showModal_1746_getActionArgs,
        events: [],
      }
    );
    const evh_2596033535867385_clickPrevent_1745 = new actions.EventHandlerImpl(
      {
        action: act_2596033535867385_showModal_1746,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2596033535867385_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2596033535867385_clickPrevent_1745],
      }
    );
    const act_2660996057968802_showModal_1748 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2660996057968802_showModal_1748_getActionArgs,
        events: [],
      }
    );
    const evh_2660996057968802_clickPrevent_1747 = new actions.EventHandlerImpl(
      {
        action: act_2660996057968802_showModal_1748,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2660996057968802_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2660996057968802_clickPrevent_1747],
      }
    );
    const act_2344870777941005_showModal_1750 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2344870777941005_showModal_1750_getActionArgs,
        events: [],
      }
    );
    const evh_2344870777941005_clickPrevent_1749 = new actions.EventHandlerImpl(
      {
        action: act_2344870777941005_showModal_1750,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2344870777941005_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2344870777941005_clickPrevent_1749],
      }
    );
    const act_2858245741222179_showModal_1752 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2858245741222179_showModal_1752_getActionArgs,
        events: [],
      }
    );
    const evh_2858245741222179_clickPrevent_1751 = new actions.EventHandlerImpl(
      {
        action: act_2858245741222179_showModal_1752,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2858245741222179_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2858245741222179_clickPrevent_1751],
      }
    );
    const act_5458292690736167_showModal_1754 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5458292690736167_showModal_1754_getActionArgs,
        events: [],
      }
    );
    const evh_5458292690736167_clickPrevent_1753 = new actions.EventHandlerImpl(
      {
        action: act_5458292690736167_showModal_1754,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5458292690736167_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5458292690736167_clickPrevent_1753],
      }
    );
    const act_5517551119992435_showModal_1756 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5517551119992435_showModal_1756_getActionArgs,
        events: [],
      }
    );
    const evh_5517551119992435_clickPrevent_1755 = new actions.EventHandlerImpl(
      {
        action: act_5517551119992435_showModal_1756,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5517551119992435_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5517551119992435_clickPrevent_1755],
      }
    );
    const act_2718428830017525_showModal_1758 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2718428830017525_showModal_1758_getActionArgs,
        events: [],
      }
    );
    const evh_2718428830017525_clickPrevent_1757 = new actions.EventHandlerImpl(
      {
        action: act_2718428830017525_showModal_1758,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_2718428830017525_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_2718428830017525_clickPrevent_1757],
      }
    );
    const act_4595210157189327_showModal_1760 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4595210157189327_showModal_1760_getActionArgs,
        events: [],
      }
    );
    const evh_4595210157189327_clickPrevent_1759 = new actions.EventHandlerImpl(
      {
        action: act_4595210157189327_showModal_1760,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_4595210157189327_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_4595210157189327_clickPrevent_1759],
      }
    );
    const act_298118714321807_script_1762 = new actions.ScriptAction(
      {
        actionArgs: this.act_298118714321807_script_1762_getActionArgs,
        events: [],
      }
    );
    const evh_298118714321807_change_1761 = new actions.EventHandlerImpl(
      {
        action: act_298118714321807_script_1762,
        event: "change",
        displayName: "script",
      }
    );
    const evh_298118714321807_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_298118714321807_change_1761],
      }
    );
    const act_7106235911078350_logout_1764 = new actions.LogoutAction(
      {
        actionArgs: this.act_7106235911078350_logout_1764_getActionArgs,
        events: [],
      }
    );
    const evh_7106235911078350_clickPrevent_1763 = new actions.EventHandlerImpl(
      {
        action: act_7106235911078350_logout_1764,
        event: "click.prevent",
        displayName: "logout",
      }
    );
    const evh_7106235911078350_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_7106235911078350_clickPrevent_1763],
      }
    );
    const act_5361165673534032_showModal_1766 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5361165673534032_showModal_1766_getActionArgs,
        events: [],
      }
    );
    const evh_5361165673534032_clickPrevent_1765 = new actions.EventHandlerImpl(
      {
        action: act_5361165673534032_showModal_1766,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_5361165673534032_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5361165673534032_clickPrevent_1765],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_1718,
      evh_7315092382398562_reload_1717,
      evh_7315092382398562_reload,
      act_4446976243747050_showModal_1720,
      evh_4446976243747050_clickPrevent_1719,
      evh_4446976243747050_clickPrevent,
      act_5794187517758435_showModal_1722,
      evh_5794187517758435_clickPrevent_1721,
      evh_5794187517758435_clickPrevent,
      act_8440793417118356_showModal_1724,
      evh_8440793417118356_clickPrevent_1723,
      evh_8440793417118356_clickPrevent,
      act_6201675214105229_showModal_1726,
      evh_6201675214105229_clickPrevent_1725,
      evh_6201675214105229_clickPrevent,
      act_6373990564425123_showModal_1728,
      evh_6373990564425123_clickPrevent_1727,
      evh_6373990564425123_clickPrevent,
      act_8819772728062230_showModal_1730,
      evh_8819772728062230_clickPrevent_1729,
      evh_8819772728062230_clickPrevent,
      act_1886107574314164_showModal_1732,
      evh_1886107574314164_clickPrevent_1731,
      evh_1886107574314164_clickPrevent,
      act_7260361660686930_showModal_1734,
      evh_7260361660686930_clickPrevent_1733,
      evh_7260361660686930_clickPrevent,
      act_5449511595610967_showModal_1736,
      evh_5449511595610967_clickPrevent_1735,
      evh_5449511595610967_clickPrevent,
      act_5934241105726385_showModal_1738,
      evh_5934241105726385_clickPrevent_1737,
      evh_5934241105726385_clickPrevent,
      act_7807097906137782_showModal_1740,
      evh_7807097906137782_clickPrevent_1739,
      evh_7807097906137782_clickPrevent,
      act_2338624680052783_showModal_1742,
      evh_2338624680052783_clickPrevent_1741,
      evh_2338624680052783_clickPrevent,
      act_8542963707987136_showModal_1744,
      evh_8542963707987136_clickPrevent_1743,
      evh_8542963707987136_clickPrevent,
      act_2596033535867385_showModal_1746,
      evh_2596033535867385_clickPrevent_1745,
      evh_2596033535867385_clickPrevent,
      act_2660996057968802_showModal_1748,
      evh_2660996057968802_clickPrevent_1747,
      evh_2660996057968802_clickPrevent,
      act_2344870777941005_showModal_1750,
      evh_2344870777941005_clickPrevent_1749,
      evh_2344870777941005_clickPrevent,
      act_2858245741222179_showModal_1752,
      evh_2858245741222179_clickPrevent_1751,
      evh_2858245741222179_clickPrevent,
      act_5458292690736167_showModal_1754,
      evh_5458292690736167_clickPrevent_1753,
      evh_5458292690736167_clickPrevent,
      act_5517551119992435_showModal_1756,
      evh_5517551119992435_clickPrevent_1755,
      evh_5517551119992435_clickPrevent,
      act_2718428830017525_showModal_1758,
      evh_2718428830017525_clickPrevent_1757,
      evh_2718428830017525_clickPrevent,
      act_4595210157189327_showModal_1760,
      evh_4595210157189327_clickPrevent_1759,
      evh_4595210157189327_clickPrevent,
      act_298118714321807_script_1762,
      evh_298118714321807_change_1761,
      evh_298118714321807_change,
      act_7106235911078350_logout_1764,
      evh_7106235911078350_clickPrevent_1763,
      evh_7106235911078350_clickPrevent,
      act_5361165673534032_showModal_1766,
      evh_5361165673534032_clickPrevent_1765,
      evh_5361165673534032_clickPrevent,
    }
  }
}

Vue.component("MainMenu", MainMenu);

</script>